import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "section-header-with-tabs"
};
const _hoisted_2 = {
  class: "title-and-tabs-wrapper"
};
const _hoisted_3 = {
  class: "tab-item-wrapper"
};
const _hoisted_4 = {
  key: 0,
  class: "title-underline"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "title-underline"
};
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'SectionTitleWithTabs',
  props: {
    title: {
      type: String,
      required: true
    },
    showMore: {
      type: Boolean,
      default: true
    },
    showTabs: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    },
    defaultActiveTab: {
      type: Number,
      default: 0
    }
  },
  emits: ['more-click', 'tab-change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const activeTab = ref(props.defaultActiveTab);
    const handleMoreClick = () => {
      emit('more-click');
    };
    const handleTabClick = index => {
      activeTab.value = index;
      emit('tab-change', index);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(["title-box", {
          active: activeTab.value === 0
        }]),
        onClick: _cache[0] || (_cache[0] = $event => handleTabClick(0))
      }, _toDisplayString(__props.title), 3), activeTab.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : _createCommentVNode("", true)]), __props.showTabs && __props.tabs.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(__props.tabs, (tab, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "tab-item-wrapper"
        }, [_createElementVNode("div", {
          class: _normalizeClass(["tab-box", {
            active: activeTab.value === index + 1
          }]),
          onClick: $event => handleTabClick(index + 1)
        }, _toDisplayString(tab), 11, _hoisted_5), activeTab.value === index + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true)]);
      }), 128)) : _createCommentVNode("", true)]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "title-line"
      }, null, -1)), __props.showMore ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "more-btn",
        onClick: handleMoreClick
      }, "更多+")) : _createCommentVNode("", true)]);
    };
  }
});